<template>
  <div class="dubbing-timeline" :style="{width: totalWidth + 'px'}" v-drag>
    <div class="total-time-width" data-action="ruler" :style="{width: totalTime * secondWidth + 'px'}">
      <div
        class="scenes-time-line"
        v-for="(s,j) in scenesTime"
        :key="j"
        :style="{left: secondWidth*s + 'px'}"
      >
      </div>
      <div
        v-show="!isPlay && showAddBtn"
        class="add-btn"
        @click="addDubbing"
        :style="{left: secondWidth*nowTime + 'px'}"
      >
        <i></i>
        <span>添加配音</span>
      </div>
    </div>
    <div
      class="drag-box-content"
      :class="{active: i===dubbingIndex}"
      v-for="(s, i) in simple"
      :key="s.start+s.text"
      :style="{
        left:secondWidth*s.start + 'px',
        width: secondWidth*s.dura + 'px'
      }"
    >
      <div class="drag-left" data-action="left" :data-index="i"></div>
      <div class="drag-right" data-action="right" :data-index="i"></div>
      <div class="drag-move" data-action="move" :data-index="i">{{s.text}}</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import timelineMixins from './timelineMixins'

export default {
  name: 'dubbingTimeline',
  mixins: [timelineMixins],
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      dubbingIndex: "addSoundtrack/getDubbingIndex", // 选中的配音数组的index
      dubbingArr: "addSoundtrack/getDubbingArr", // 配音数组
    })
  },
  watch: {
    "dubbingArr.length": function() {
      this.calcDubbings()
      this.checkAdd();
    }
  },
  mounted() {
    this.$bus.on("subtitle_undoRodo_execute", ({mod, type}) => {
      if(mod === "updateDubbing" || mod === 'updateDubbingGroup') {
        this.calcDubbings()
        if(this.subIndex > -1) {
          this.$emit('changeNowTime', this.simple[this.dubbingIndex].start);
        }
        this.checkAdd()
      }
    })
    this.$bus.on('replace_current_dubing', ({event} = {}) => {
      if(event === 'clip') {
        if(this.dubbingIndex > -1) {
          let max = this.totalTime;
          if(this.dubbingIndex < this.simple.length -1) {
            max = this.simple[this.dubbingIndex + 1].start;
          }
          let dub = this.dubbingArr[this.dubbingIndex];
          let long = dub.cut[1] - dub.cut[0];
          let end = dub.timeSlot[1];
          if(long + dub.timeSlot[0] > max) {
            end = max;
          } else {
            end = dub.timeSlot[0] + long;
          }
          this.$store.commit("addSoundtrack/updateDubbing", {index: this.dubbingIndex, dubbing: {
            timeSlot: [dub.timeSlot[0], end]
          }});
        }
      }
      this.calcDubbings();
      this.checkAdd();
    })
    this.$bus.on('record-sound-add', dubbing => {
      let index = this.checkAdd(dubbing.timeSlot[0]);
      if(!this.showAddBtn) {
        this.$message({
          showClose: true,
          message: '当前位置已有配音',
          type: 'error'
        });
        this.checkAdd();
        return;
      }
      let end = this.totalTime;
      if(this.simple[index]) {
        end = this.simple[index].start;
      }
      if(end < dubbing.timeSlot[1]){
        dubbing.timeSlot[1] = end;
      }
      this.$store.commit("addSoundtrack/addDubbing", {
        dubbing,
        index
      });
      this.$store.commit("addSoundtrack/setDubbingIndex", index);
      this.$bus.emit("insert_subtitle_undo", {
        type: "addDubbing",
        data: {
          index: index,
          data: JSON.stringify(dubbing),
        },
      });
    })
  },
  beforeDestroy () {
    this.$bus.$off("subtitle_undoRodo_execute");
    this.$bus.$off("replace_current_dubing");
    this.$bus.$off("record-sound-add");
  },
  methods: {
    initData() {
      this.calcDubbings();
      this.checkAdd();
    },
    calcDubbings() {
      let part = null;
      let sub = null;
      this.simple = [];
      for (let i in this.dubbingArr) {
        sub = this.dubbingArr[i];
        part = {
          start: sub.timeSlot[0],
          end: sub.timeSlot[1]
        };
        part.dura = part.end - part.start;
        part.text = sub.text || sub.title;
        part.long = sub.cut[1] - sub.cut[0];

        if(part.dura < 0.2) {
          this.$store.commit("addSoundtrack/delDubbing", i);
          i--;
          continue;
        }

        if(part.end > this.totalTime) {
          // 配音大于时间的时候（删除配音或者截取）
          // let j = +i;
          if(this.totalTime - part.start >= 0.2) {
            part.end = this.totalTime;
            part.dura = part.end - part.start;
            // this.$store.commit("addSoundtrack/updateDubbing", {index: j, dubbing: {
            //   timeSlot: [part.start, part.end]
            // }});
            this.simple.push(part);
            // j++
          }
          // while (this.dubbingArr && this.dubbingArr.length > j) {
          //   this.$store.commit("addSoundtrack/delDubbing", j);
          // }
          return;
        }
        this.simple.push(part);
      }
    },
    addDubbing() {
      let index = this.checkAdd();
      if(!this.showAddBtn) return;
      let start = this.nowTime;
      let end = this.totalTime;
      if(this.simple[index]) {
        end = this.simple[index].start;
      }
      this.$store.commit("addSoundtrack/setSoundtrackState", {
        state:true,
        type:'dub',
        start,
        end,
        index,
        operation: "add",
      });
    },
    setSelectIndex(i) {
      this.settingPanel(i, 'dub');
      this.indexS = i;
      this.$store.commit("addSoundtrack/setMusicIndex", -1);
      this.$store.commit("subtitle/setSubIndex", -1);
      this.$store.commit("addSoundtrack/setDubbingIndex", i);
    },
    changeSelect(){
      let dubbing = {
        timeSlot: [+this.simple[this.indexS].start.toFixed(3), +this.simple[this.indexS].end.toFixed(3)]
      }
      this.$bus.emit("insert_subtitle_undo", {
        type: "updateDubbing",
        data: {
          index: this.indexS,
          reData: JSON.stringify({timeSlot: this.dubbingArr[this.indexS].timeSlot}),
          data: JSON.stringify(dubbing)
        }
      });
      this.$store.commit("addSoundtrack/updateDubbing", { dubbing });
      this.checkAdd();
    }
  }
}
</script>
<style lang="scss" scrope>
@import './timeline.scss';

.dubbing-timeline {
  position: relative;
  left: 10px;
  top: 0;
  height: 24px;
  width: 100px;
  margin: 5px 0;
  background-color: #e5e6f0;
  border-radius: 4px;
}
</style>




// WEBPACK FOOTER //
// src/components/timelineContent/dubbing.vue